<template>
  <div>
    <button v-on:click.prevent="showAddForm = !showAddForm">Добавить запись в раздел "{{item.title}}"</button>
    <div class="cc_item_tab" v-if="showAddForm">
      <p>укажите шаблон новой записи в разделе "{{item.title}}"</p>
      <select class="cc_cd_type_item" v-model="typeItem">
        <option value="folder">Раздел</option>
        <option value="faq">Вопрос\ответ</option>
      </select>

      <div class="folder_add cc_tab_form" v-if="typeItem != undefined && typeItem == 'folder'">
        <input type="text" v-model="folderAddTitle" placeholder="Введите заголовок раздела">
        <input type="text" v-model="folderAddSort" placeholder="Укажите порядковый номер в списке">
        <button  v-on:click.prevent="saveAddItem"> Добавить</button>
      </div>
      <div class="faq_add cc_tab_form" v-if="typeItem != undefined && typeItem == 'faq'">
        <input type="text" v-model="folderAddTitle" placeholder="Введите вопрос">
        <input type="text" v-model="folderAddSort" placeholder="Укажите порядковый номер в списке">
        <vue-editor v-model="folderAddContent"></vue-editor>
        <button v-on:click.prevent="saveAddItem">Добавить</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  export default {
    name: "editScriptAddItem",
    data(){
      return{
        showAddForm:false,
        typeItem:undefined,
        folderAddTitle:'',
        folderAddSort:'',
        folderAddContent:'',
      }
    },
    components:{
      VueEditor
    },
    methods:{
      saveAddItem() {
        this.$myApi.singleRequest({
          action:'OperatorScript_addFolder',
          title:this.folderAddTitle,
          sort:this.folderAddSort,
          parent:this.item.id,
          template:this.typeItem,
          source:this.scriptID,
          content:this.folderAddContent,
        }).then((res)=>{
          console.log(res);
          this.showAddForm =false;
            this.typeItem=undefined;
            this.folderAddTitle='';
            this.folderAddSort='';
            this.folderAddContent='';
          this.$store.dispatch('loadScriptById',this.scriptID);
        }).catch((res)=>{
          alert(res);
        });
      },
    },
    props:{
      item:{
        type:Object,
        default:()=>{
          return {};
        }
      },
      scriptID:{
        type:String,
        default:0,
      }
    }
  }
</script>

<style scoped>

</style>
